import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from '../../context/LanguageContext';
import './ShopProduct.css';

const ShopProduct = ({ products }) => {
    const { t } = useLanguage();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <section className="wpo-shop-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="shop-grids clearfix">
                            {products.length > 0 &&
                                products.map((product, pitem) => (
                                    <div className="grid" key={pitem}>
                                        <div className="img-holder">
                                            <img src={product.proImg} alt={product.title} />
                                        </div>
                                        <div className="details">
                                            <h3>
                                                <Link onClick={ClickHandler} to={`/shop-single/${product.slug}`}>
                                                    {product.title}
                                                </Link>
                                            </h3>
                                            <Link
                                                onClick={ClickHandler}
                                                to={`/shop-single/${product.slug}`}
                                                className="theme-btn-s2"
                                            >
                                                {t('shop.viewDetail')}
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ShopProduct;
